/* @flow */
import { paths } from '@/config';

export default function getSaleId() {
  return window.location.pathname.split(`${paths.fishes.root}/`)[1];
}
